export function stopEvent(e: Event) {
	// we handled the key, prevent everything else
	e.preventDefault();
	e.stopPropagation();
	e.stopImmediatePropagation();
	return false;
}

export function isRightClick(e: MouseEvent) {
	return e.button === 2;
}

export function getTagName(e: MouseEvent) {
	return (e.target as HTMLElement).tagName;
}
